// extracted by mini-css-extract-plugin
export default {"primary":"textarea_primary__yOqwo","textarea":"textarea_textarea__F89qr","disabled":"textarea_disabled__gX8MA","isLoading":"textarea_isLoading__DSv9Q"};